import {
    IExternalDirectory,
    IExternalDirectoryActionTypes,
} from "./types";
import { IExternalDirectoryActions } from "./actions";

const defaultState: IExternalDirectory = {
    contacts: [],
    isLoading: undefined,
    editContactLoading: false,
    deleteContactLoading: false,
    errors: [],
    manageExternalDirectorySearchParams: {},
};

const externalDirectoryReducer = (
    state = defaultState,
    action: IExternalDirectoryActions
) => {
    switch (action.type) {
        case IExternalDirectoryActionTypes.SET_EXTERNAL_DIRECTORY:
            return { ...state, contacts: action.payload };

        case IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_LOADING:
            return { ...state, isLoading: action.payload };

        case IExternalDirectoryActionTypes.ADD_EXTERNAL_DIRECTORY_ITEM:
            return {
                ...state,
                editContactLoading: false,
                contacts: [...state.contacts, action.payload],
            };

        case IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM:
            return {
                ...state,
                editContactLoading: false,
                contacts: state.contacts.map((contact) => {
                    return contact.id !== action.payload.id
                        ? contact
                        : action.payload;
                }),
            };

        case IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM_LOADING:
            return {
                ...state,
                editContactLoading: action.payload,
            };

        case IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM:
            return {
                ...state,
                deleteContactLoading: false,
                contacts: state.contacts.filter((contact) => {
                    return contact.id !== action.payload;
                }),
            };

        case IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM_LOADING:
            return {
                ...state,
                deleteContactLoading: action.payload,
            };

        case IExternalDirectoryActionTypes.SET_MANAGE_EXTERNAL_DIRECTORY_SEARCH_PARAMS:
            return {
                ...state,
                manageExternalDirectorySearchParams: {
                    ...state.manageExternalDirectorySearchParams,
                    ...action.payload,
                },
            };

        case IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_ERROR:
            return {
                ...state,
                errors: [...state.errors, action.payload],
            };

        default:
            return state;
    }
};

export default externalDirectoryReducer;
